import ResultsSlice from "../../valueObjects/ResultsSlice.js";

const notEmptyResultsSlice = function(slice) {
    return slice instanceof ResultsSlice
        && slice.getSmallestSlice().length > 0;
};

export default notEmptyResultsSlice;